var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-4"},[_c('div',{staticClass:"row bg-primary p-3 rounded text-white"},[_c('div',{staticClass:"col-1"},[_c('icon',{staticClass:"fa-6x",attrs:{"icon":['fad', 'thumbs-up']}})],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col d-flex"},[_c('h5',{staticClass:"my-auto"},[_vm._v(" Thank you for uploading your poster.")])])
}]

export { render, staticRenderFns }